import tippy from 'tippy.js';

tippy('.u-tooltip', {
  theme: 'nienhuys',
  content(ref) {
    const content = ref.querySelector('.u-tooltip__content');
    return content.innerHTML;
  },
  allowHTML: true,
  offset: [0, 36],
})

tippy('.u-tooltip--svg', {
  theme: 'nienhuys-dark',
  allowHTML: true,
  offset: [0, 10],
})
